import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\AuthenticatorAppController::setup
 * @see app/Http/Controllers/AuthenticatorAppController.php:35
 * @route '/account/2fa/authenticator/setup'
 */
export const setup = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: setup.url(options),
    method: 'post',
})

setup.definition = {
    methods: ["post"],
    url: '/account/2fa/authenticator/setup',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\AuthenticatorAppController::setup
 * @see app/Http/Controllers/AuthenticatorAppController.php:35
 * @route '/account/2fa/authenticator/setup'
 */
setup.url = (options?: RouteQueryOptions) => {
    return setup.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AuthenticatorAppController::setup
 * @see app/Http/Controllers/AuthenticatorAppController.php:35
 * @route '/account/2fa/authenticator/setup'
 */
setup.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: setup.url(options),
    method: 'post',
})

    /**
* @see \App\Http\Controllers\AuthenticatorAppController::setup
 * @see app/Http/Controllers/AuthenticatorAppController.php:35
 * @route '/account/2fa/authenticator/setup'
 */
    const setupForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
        action: setup.url(options),
        method: 'post',
    })

            /**
* @see \App\Http\Controllers\AuthenticatorAppController::setup
 * @see app/Http/Controllers/AuthenticatorAppController.php:35
 * @route '/account/2fa/authenticator/setup'
 */
        setupForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
            action: setup.url(options),
            method: 'post',
        })
    
    setup.form = setupForm
/**
* @see \App\Http\Controllers\AuthenticatorAppController::confirm
 * @see app/Http/Controllers/AuthenticatorAppController.php:49
 * @route '/account/2fa/authenticator/confirm'
 */
export const confirm = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: confirm.url(options),
    method: 'post',
})

confirm.definition = {
    methods: ["post"],
    url: '/account/2fa/authenticator/confirm',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\AuthenticatorAppController::confirm
 * @see app/Http/Controllers/AuthenticatorAppController.php:49
 * @route '/account/2fa/authenticator/confirm'
 */
confirm.url = (options?: RouteQueryOptions) => {
    return confirm.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AuthenticatorAppController::confirm
 * @see app/Http/Controllers/AuthenticatorAppController.php:49
 * @route '/account/2fa/authenticator/confirm'
 */
confirm.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: confirm.url(options),
    method: 'post',
})

    /**
* @see \App\Http\Controllers\AuthenticatorAppController::confirm
 * @see app/Http/Controllers/AuthenticatorAppController.php:49
 * @route '/account/2fa/authenticator/confirm'
 */
    const confirmForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
        action: confirm.url(options),
        method: 'post',
    })

            /**
* @see \App\Http\Controllers\AuthenticatorAppController::confirm
 * @see app/Http/Controllers/AuthenticatorAppController.php:49
 * @route '/account/2fa/authenticator/confirm'
 */
        confirmForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
            action: confirm.url(options),
            method: 'post',
        })
    
    confirm.form = confirmForm
/**
* @see \App\Http\Controllers\AuthenticatorAppController::destroy
 * @see app/Http/Controllers/AuthenticatorAppController.php:94
 * @route '/account/2fa/authenticator'
 */
export const destroy = (options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/account/2fa/authenticator',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\AuthenticatorAppController::destroy
 * @see app/Http/Controllers/AuthenticatorAppController.php:94
 * @route '/account/2fa/authenticator'
 */
destroy.url = (options?: RouteQueryOptions) => {
    return destroy.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AuthenticatorAppController::destroy
 * @see app/Http/Controllers/AuthenticatorAppController.php:94
 * @route '/account/2fa/authenticator'
 */
destroy.delete = (options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(options),
    method: 'delete',
})

    /**
* @see \App\Http\Controllers\AuthenticatorAppController::destroy
 * @see app/Http/Controllers/AuthenticatorAppController.php:94
 * @route '/account/2fa/authenticator'
 */
    const destroyForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
        action: destroy.url({
                    [options?.mergeQuery ? 'mergeQuery' : 'query']: {
                        _method: 'DELETE',
                        ...(options?.query ?? options?.mergeQuery ?? {}),
                    }
                }),
        method: 'post',
    })

            /**
* @see \App\Http\Controllers\AuthenticatorAppController::destroy
 * @see app/Http/Controllers/AuthenticatorAppController.php:94
 * @route '/account/2fa/authenticator'
 */
        destroyForm.delete = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
            action: destroy.url({
                        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
                            _method: 'DELETE',
                            ...(options?.query ?? options?.mergeQuery ?? {}),
                        }
                    }),
            method: 'post',
        })
    
    destroy.form = destroyForm
const authenticator = {
    setup: Object.assign(setup, setup),
confirm: Object.assign(confirm, confirm),
destroy: Object.assign(destroy, destroy),
}

export default authenticator